export default __webpack_public_path__ + "static/media/trust_and_will_page.80b427d8.pdf";